// extracted by mini-css-extract-plugin
export default {"swiperButtons":"SwiperCompanyRefill_swiperButtons__vukWW","card":"SwiperCompanyRefill_card__veuXt","btnL":"SwiperCompanyRefill_btnL__zL-Vm","btnR":"SwiperCompanyRefill_btnR__+7bLL"};